<template>
  <div
    :class="{'delete-hover-avatar position-relative': isHovered, 'empty-icon-avatar': !isHovered}"
    class="d-flex align-items-center justify-content-center w-4 h-4"
    title="Click to delete the company."
    @mouseenter="toggleHoverState"
    @mouseleave="toggleHoverState"
    @click="$emit('click')"
  >
    <img
      v-if="isHovered"
      src="@/assets/icons/card_delete_hover.svg"
      alt="Delete icon (hovered)"
    />
    <img
      v-else
      class="cursor-pointer"
      src="@/assets/icons/card_delete.svg"
      alt="Delete"
    />
  </div>
</template>

<script>
export default {
  name: "DeleteButton",
  data() {
    return {
      isHovered: false
    }
  },
  methods: {
    toggleHoverState() {
      this.isHovered = !this.isHovered
    }
  }
};
</script>

<style scoped>
.w-4 {
  width: 2.5rem;
}
.h-4 {
  height: 2.5rem;
}

.delete-hover-avatar {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 2.5rem;
  cursor: pointer;
  padding: 2rem;
}
</style> 